import RetailerCardCompact from './retailer-card/compact';
import RetailerCardLarge from './retailer-card/large';

/**
 * The Retailer component displays information about a single retailer location.
 *
 * @param {Object}  props                  Properties passed to the component.
 * @param {Object}  props.data             The retailer data object
 * @param {boolean} props.showLogos        Whether to show the logos or the distance of the retailer
 * @param {string}  props.displayMode      The display mode of the retailer (compact or large).
 * @param {boolean} props.hideAddressField If true, hide the address field
 * @param {boolean} props.hidePhoneField   If true, hide the phone field
 * @param {boolean} props.hideWebsiteField If true, hide the website field
 * @return {JSX.Element}  A JSX element representing a retailer location.
 */
const Retailer = ( { data, showLogos, displayMode, hideAddressField, hidePhoneField, hideWebsiteField } ) => {
	if ( displayMode === 'compact' ) {
		return <RetailerCardCompact data={ data } showLogos={ showLogos } hideAddressField={ hideAddressField } hidePhoneField={ hidePhoneField } hideWebsiteField={ hideWebsiteField } />;
	}

	return <RetailerCardLarge data={ data } showLogos={ showLogos } hideAddressField={ hideAddressField } hidePhoneField={ hidePhoneField } hideWebsiteField={ hideWebsiteField } />;
};

export default Retailer;
